import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDriverDelete, useDrivers } from './apiHooks';
import utils from '../../utils/utils';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';
import DriverForm from './driverForm';

const RoutePlannerDrivers = ({}) => {
  const { formatMessage } = useIntl();

  const [showCreateForm, setShowCreateForm] = useState(false);
  const [editDriver, setEditDriver] = useState(null);

  const { result, isLoading, isError, error } = useDrivers();
  const { deleteDriver, isLoading: deleteLoading, isError: isDeleteError, error: deleteError } = useDriverDelete();

  return (
    <>
      <div className="route-planner-index">
        <h2 className="m-b-6">
          <FormattedMessage id={'route.planner.drivers.header'} />
        </h2>

        <div className="m-b-6">
          <button className="btn btn-primary" onClick={() => setShowCreateForm(true)}>
            <FormattedMessage id={'route.planner.index.driver.create'} />
          </button>
        </div>

        <Loader show={isLoading} />
        {isError || isDeleteError ? (
          <ErrorMessage error={utils.getErrorMessageFromResponse(error || deleteError)} />
        ) : (
          ''
        )}

        {result?.drivers ? (
          result.drivers.length ? (
            <div className="row m-b-6">
              <div className="col-12 col-xl-6">
                {result?.drivers.map((driver) => {
                  return (
                    <div key={driver.id} className="route-planner__plan m-b-3">
                      <h3>🚙 {driver.name}</h3>
                      <div>
                        <button
                          className={`btn btn-default btn-small m-r-2 ${deleteLoading ? 'btn-loading' : ''}`}
                          onClick={() => {
                            setEditDriver(driver);
                          }}
                        >
                          <FormattedMessage id={'route.planner.drivers.cta.edit'} />
                        </button>
                        <button
                          className={`btn btn-danger btn-small m-r-2 ${deleteLoading ? 'btn-loading' : ''}`}
                          onClick={() => {
                            if (window.confirm(formatMessage({ id: 'route.planner.drivers.cta.delete.confirm' }))) {
                              deleteDriver({ driver });
                            }
                          }}
                        >
                          <FormattedMessage id={'route.planner.drivers.cta.delete'} />
                        </button>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : (
            <p>
              <FormattedMessage id={'route.planner.drivers.empty'} />
            </p>
          )
        ) : (
          ''
        )}
      </div>

      <Modal show={!!editDriver} onHide={() => setEditDriver(null)} size="md">
        <div onClick={() => setEditDriver(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editDriver ? <DriverForm driverId={editDriver.id} onSuccess={() => setEditDriver(null)} /> : ''}
        </div>
      </Modal>

      <Modal show={!!showCreateForm} onHide={() => setShowCreateForm(false)} size="md">
        <div onClick={() => setShowCreateForm(false)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">{showCreateForm ? <DriverForm onSuccess={() => setShowCreateForm(false)} /> : ''}</div>
      </Modal>
    </>
  );
};

RoutePlannerDrivers.propTypes = {
  currentUser: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default connect(mapStateToProps)(RoutePlannerDrivers);
